import { Checkbox, CheckboxProps } from "@mui/material";
import { t } from "i18next";
import TooltipComponent from "./TooltipComponent";

class ToggleableCheckboxProps {
    editMode = false;
    render?: (checked?: boolean) => JSX.Element
    disabledTooltip?: string
}

export default function ToggleableCheckbox(props: CheckboxProps & ToggleableCheckboxProps) {
    if (props.editMode)
        return (
            props.disabled && props.disabledTooltip ?
                <TooltipComponent title={props.disabledTooltip}>
                    <Checkbox {...props} />
                </TooltipComponent> :
            <Checkbox {...props} />
        )

    if (props.render)
        return props.render(props.checked);

    return <>{props.checked ? t("Yes") : t("No")}</>;
}